import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';

export const IncontactavelDialog = ({ lead, onClose, onConfirm }) => {
  const [note, setNote] = useState('');
  useEffect(() => { setNote(''); }, [lead]);
  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="incontactavel-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle>{lead?.client_name}: Incontactável</DialogTitle></DialogHeader>
        <div>
          <label className="text-xs text-slate-500 mb-1 block">Nota obrigatória</label>
          <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3} maxLength={500}
            className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm" placeholder="Ex.: liguei 3x, não atende"
            data-testid="incontactavel-note-input" />
          <p className="text-[11px] text-slate-400 mt-1">Vai receber um lembrete para voltar a tentar ao fim de 7 dias.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button disabled={!note.trim()} onClick={() => onConfirm(note.trim())} className="bg-orange-600 hover:bg-orange-700" data-testid="incontactavel-confirm">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
